import { Suspense, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Navbar from './Navbar'
import Footer from './Footer'
import CookieBanner from './CookieBanner'
import FesttagePopup from './FesttagePopup'
import { API_BASE_URL } from '../config/api'
import { connectCockpit } from '../lib/cockpit'

export default function Layout() {
  const { pathname } = useLocation()

  useEffect(() => {
    if (pathname.startsWith('/dashboard')) return
    const send = () => {
      const base = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL
      const url = `${base}/analytics/ping?path=${encodeURIComponent(pathname)}`
      fetch(url, { method: 'GET', keepalive: true }).catch(() => {})
      if (localStorage.getItem('cookieConsent') === 'accepted') {
        connectCockpit(pathname)
      }
    }
    if (typeof window.requestIdleCallback === 'function') {
      const id = window.requestIdleCallback(send, { timeout: 3000 })
      return () => window.cancelIdleCallback(id)
    }
    const timer = window.setTimeout(send, 1500)
    return () => window.clearTimeout(timer)
  }, [pathname])

  useEffect(() => {
    const onConsent = () => {
      if (!pathname.startsWith('/dashboard')) connectCockpit(pathname)
    }
    window.addEventListener('jokic-cockpit-consent', onConsent)
    return () => window.removeEventListener('jokic-cockpit-consent', onConsent)
  }, [pathname])

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Suspense fallback={<div className="min-h-screen" />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <CookieBanner />
      <FesttagePopup />
    </div>
  )
}

















